<template xmlns="http://www.w3.org/1999/html">
  <div class="meeting-list planning">
    <Header
        :authVars="authVars"
        :loading="loading"
        title="Créneaux"
        @go-home="homePage"
    >
      <!-- slot nommé 'meta' pour la plage horaire spécifique à MeetingList -->
      <template #meta>
        <div>
          <span v-if="planningList.length > 0">
            {{ formatDate(minStartDate) }} de {{ formatTime(minStartDate) }} à {{ formatTime(maxEndDate) }}
          </span>
        </div>
      </template>

      <!-- slot par défaut : actions (boutons, logout...) -->
      <button class="btn btn-primary btn-sm" @click="goPlanning">← Retour</button>

      <LogoutButton :userAccountObjId="authVars.userAccountObjId"/>
    </Header>

    <!-- Calendrier mensuel -->
    <MonthlyCalendar
        :day-headers="CALENDAR_CONFIG.DAY_HEADERS"
        :enable-day-click="false"
        :has-content-on-date="hasPlanningOnDate"
        :is-date-selected="isSelected"
        :months="monthsToDisplay"
        :show-navigation="false"
    />

    <div v-if="error" class="error alert alert-danger">
      {{ error }}
      <button class="close" @click="clearError">&times;</button>
    </div>

    <div v-for="(planning, index) in planningList" :id="`planning-${planning.id}`" :key="planning.id" class="planning-section">
      <div class="planning-info">
        <p class="cursor-pointer" style="display: inline-block;" @click="editPlanning(planning)">
          <strong>Entretiens réalisés par : </strong>
          <span class="underline" style="color: var(--primary);">
            {{ formatPersonDisplayName(planning.interviewManager) }}
          </span>
          <span style="margin-left: 5px;">✎</span><br/>
          <span v-if="planning.ofCandidatureMeeting">
            <strong style="font-size: 0.9rem; margin-top: 6px;">Adresse de l'entretien :</strong><br>
            <span style="font-size: 0.75rem; color: #666; line-height: 1.2; margin-top: 4px;">
             <span style="font-size: 1.1em; color: #e63946; flex-shrink: 0;">📍</span>{{ planning.ofCandidatureMeeting.ofName }}<br>
              <span style="margin-left: 5px">{{ planning.ofCandidatureMeeting.campusAddress }}<br></span>
               <span style="margin-left: 5px">{{ planning.ofCandidatureMeeting.campusPostalCode }} {{ planning.ofCandidatureMeeting.campusCityName }}
                </span>
              </span>
          </span>

        </p>
        <span class="opacity-70" style="display: inline-block; float: right;">
          {{ formatDate(planning.startAt) }} de {{ formatTime(planning.startAt) }} à {{ formatTime(planning.endAt) }}
        </span>
      </div>

      <div v-if="planning.meetingList.length === 0" class="empty-state">
        <p>Aucun créneau disponible pour ce planning.</p>
      </div>

      <div v-else :class="{ selected: planning.selected }" class="meeting-table">
        <table class="table table-meeting">
          <thead>
          <tr style="border-bottom: 2px solid var(--primary);">
            <th style="width: 15%; border-left:6px solid var(--primary);">Heure début</th>
            <th style="width: 15%">Heure fin</th>
            <th>Candidature</th>
            <th>Statut</th>
            <th style="width: 18%">Visibilité</th>
            <th style="width: 10%"><img :src="avisOf" alt="Grille entretien" style="height: 42px;" /></th>
            <th style="width: 20%">Notes internes</th>
            <th v-if="hasProposedMeetings(planning.meetingList)" style="width: 15%;"></th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(meeting, meetingIndex) in planning.meetingList"
              :key="meeting.id"
              :class="{
              'clickable-row': true,
              'meeting-available': meeting.statut === 10,
              'meeting-proposed': meeting.statut === 20,
              'meeting-waiting': meeting.statut === 30 || meeting.statut === 31,
              'meeting-confirmed': meeting.statut === 40,
              'meeting-refused': meeting.statut === 50,
              'meeting-completed': meeting.statut === 60,
              'meeting-cancelled': meeting.statut === 70 ,
            }"
              @click="editMeeting(meeting, planning)"
              @mouseleave="handleMeetingRowMouseLeave(meeting.id)"
          >
            <template v-if="planning.grouped">
              <td
                  v-if="meetingIndex === 0"
                  :colspan="2"
                  :rowspan="planning.meetingList.length"
                  class="meeting-multi"
                  style="vertical-align: middle; text-align: center;font-weight: bold;color: #000; opacity: 1"
                  :style="{ '--multi-bg': `url(${multi})` }"
              >
                {{ formatTime(planning.startAt) }} à {{ formatTime(planning.endAt) }}
              </td>
            </template>
            <template v-else>
              <td>{{ formatTime(meeting.startAt) }}</td>
              <td>{{ formatTime(meeting.endAt) }}</td>
            </template>
            <td v-if="meeting.candidacyObjId">
            {{ formatPersonDisplayName(meeting.candidacy) }}
            </td>
            <td v-else>Aucune</td>
            <td class="meeting-status-cell">
              <span class="meeting-status-content">
                <span>{{ getStatusText(meeting.statut) }}</span>
                <span class="meeting-status-actions">
                  <button
                      v-if="canOpenReadonlyConvocationPreview(meeting)"
                      class="status-preview-btn"
                      title="Voir la convocation"
                      type="button"
                      @click.stop="openReadonlyPreview(meeting)"
                  >
                    <svg class="status-preview-icon" viewBox="0 0 24 24" aria-hidden="true">
                      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                    </svg>
                  </button>
                  <button
                      v-if="meeting.meetLink"
                      class="status-preview-btn"
                      :title="meeting.meetLink.startsWith('http') ? 'Ouvrir le lien visio' : 'Lien visio non configuré'"
                      type="button"
                      :style="!meeting.meetLink.startsWith('http') ? { color: 'orange' } : {}"
                      @click.stop="openMeetLink(meeting)"
                  >
                    <svg class="status-preview-icon" viewBox="0 0 16 16" aria-hidden="true">
                      <path d="M0 5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1.5l3.553-2.22A.5.5 0 0 1 16 4.704v6.592a.5.5 0 0 1-.447.496L12 9.573V11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"/>
                    </svg>
                  </button>
                </span>
              </span>
            </td>
            <td class="meeting-visibility-cell">
              <label v-if="meeting.statut === 10" class="visibility-switch" @click.stop>
                <input
                    :checked="meeting.public"
                    :disabled="updatingMeetingVisibilityIds.includes(meeting.id)"
                    type="checkbox"
                    @click.stop
                    @change="toggleMeetingVisibility(meeting, $event.target.checked)"
                />
                <span class="visibility-slider"></span>
                <span class="visibility-label">
                  {{ meeting.public ? 'Publique' : 'Privée' }}
                </span>
              </label>
              <span v-else class="visibility-label">
                {{ meeting.public ? 'Publique' : 'Privée' }}
              </span>
            </td>
            <td class="meeting-form-cell">
              <div
                  v-if="hasMeetingFormActions(meeting)"
                  class="meeting-form-dropdown"
                  @click.stop
              >
                <button
                    class="status-preview-btn meeting-form-dropdown-trigger"
                    title="Actions grille d'entretien"
                    type="button"
                    @click.stop="toggleMeetingFormDropdown(meeting.id)"
                >
                  <span class="meeting-form-dropdown-trigger-icon" aria-hidden="true">
                     <svg  class="status-preview-icon" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                      </svg>

                  </span>
                </button>

                <div
                    v-if="openMeetingFormDropdownId === meeting.id"
                    class="meeting-form-dropdown-menu"
                >
                  <button
                      v-if="canCreateMeetingForm(meeting) || canPreviewMeetingForm(meeting)"
                      :disabled="canCreateMeetingForm(meeting) && creatingMeetingFormIds.includes(meeting.id)"
                      class="meeting-form-dropdown-item"
                      title="Créer ou voir la grille d'entretien en ligne"
                      type="button"
                      @click.stop="handleMeetingFormOnlineAction(meeting, planning)"
                  >
                    <span class="meeting-form-dropdown-item-icon">
                      <span
                          v-if="canCreateMeetingForm(meeting)"
                          class="meeting-form-online-create-icon"
                      >
                        {{ creatingMeetingFormIds.includes(meeting.id) ? '...' : '+' }}
                      </span>
                      <svg v-else class="status-preview-icon" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                      </svg>
                    </span>
                    <span>Édition en ligne</span>
                  </button>

                  <button
                      v-if="canDownloadMeetingForm(meeting)"
                      :disabled="isMeetingFormActionBusy(meeting.id)"
                      class="meeting-form-dropdown-item"
                      title="Télécharger la grille d'entretien (PDF) prête à être renseignée"
                      type="button"
                      @click.stop="handleMeetingFormPdfAction(meeting)"
                  >
                    <span class="meeting-form-dropdown-item-icon">
                      <span v-if="downloadingMeetingFormIds.includes(meeting.id)" class="meeting-form-download-loading">
                        ...
                      </span>
                      <img v-else :src="stylo" class="status-preview-icon" alt="" aria-hidden="true" />
                    </span>
                    <span>Télécharger la grille pour une édition manuscrite</span>
                  </button>

                  <button
                      v-if="canDownloadMeetingForm(meeting)"
                      :disabled="isMeetingFormActionBusy(meeting.id)"
                      class="meeting-form-dropdown-item"
                      title="Exporter une grille d'entretien préalablement téléchargée puis renseignée vers EVA"
                      type="button"
                      @click.stop="handleMeetingFormEvaExportAction(meeting)"
                  >
                    <span class="meeting-form-dropdown-item-icon">
                      <span v-if="exportingMeetingFormToEvaIds.includes(meeting.id)" class="meeting-form-download-loading">
                        ...
                      </span>
                      <svg v-else class="status-preview-icon" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M5 20h14v-2H5v2zm7-16-5.5 5.5 1.42 1.42L11 8.84V16h2V8.84l3.08 3.08 1.42-1.42L12 4z"/>
                      </svg>
                    </span>
                    <span>
                      {{ exportingMeetingFormToEvaIds.includes(meeting.id) ? 'Upload en cours...' : 'Exporter une grille renseignée vers EVA' }}
                    </span>
                  </button>

                  <button
                      v-if="canDownloadMeetingForm(meeting)"
                      :disabled="openingAvisOFMeetingId === meeting.id"
                      class="meeting-form-dropdown-item"
                      title="Ouvrir le formulaire d'avis de l'organisme de formation"
                      type="button"
                      @click.stop="handleAvisOFAction(meeting)"
                  >
                    <span class="meeting-form-dropdown-item-icon">
                      <span v-if="openingAvisOFMeetingId === meeting.id" class="meeting-form-download-loading">
                        ...
                      </span>
                      <svg v-else class="status-preview-icon" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/>
                      </svg>
                    </span>
                    <span>{{ openingAvisOFMeetingId === meeting.id ? 'Chargement...' : "Avis de l'organisme de formation" }}</span>
                  </button>
                </div>
              </div>
            </td>
            <td class="meeting-comments-cell">
              <button
                  v-if="!hasMeetingComment(meeting)"
                  class="comment-trigger comment-empty"
                  type="button"
                  @click.stop="editMeeting(meeting, planning)"
              >
                +
              </button>
              <button
                  v-else
                  :title="meeting.comments"
                  class="comment-trigger comment-text"
                  type="button"
                  @click.stop="editMeeting(meeting, planning)"
              >
                {{ truncateComment(meeting.comments) }}
              </button>
            </td>
            <td v-if="hasProposedMeetings(planning.meetingList)">
              <!-- Bouton Envoyer la convocation -->
              <button
                  v-if="meeting.statut === 20"
                  class="btn btn-warning btn-sm invitation-btn"
                  @click.stop="openPreview(meeting)"
              >
                <span class="btn-content">
                  <span class="warning-icon">⚠</span>
                  {{ loadingInvitation === meeting.id ? 'Envoi...' : 'Envoyer la convocation' }}
                </span>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div v-if="index === planningList.length - 1" class="details-button-container mt-4">
        <!-- Ligne du checkbox aligné à droite -->
        <div class="details-top-row">
          <label class="details-checkbox">
            <input
                :checked="showDetails"
                :disabled="detailsLoading"
                name="showDetails"
                type="checkbox"
                @input="toggleDetails"
            />
            <span class="checkbox-label">Voir les fiches</span>
          </label>
        </div>

        <div class="print-button-wrapper">
          <button
              :disabled="detailsLoading"
              class="btn btn-primary btn-sm"
              @click="printWithDetails"
          >
            🖨️ Imprimer
          </button>
        </div>

      </div>


    </div>

    <!-- Composant séparé pour les détails -->
    <MeetingDetails
        :meeting-details="meetingDetails"
        :show-details="showDetails"
    />

    <MeetingEdit
        v-if="selectedMeeting && associatedPlanningToSelectedMeeting "
        :meeting="selectedMeeting"
        :planning="associatedPlanningToSelectedMeeting"
        @close="handleMeetingClosed"
        @updated="handleMeetingUpdated"
    />

    <PlanningEdit
        v-if="selectedPlanning"
        :planning="selectedPlanning"
        @close="handlePlanningClosed"
        @updated="handlePlanningUpdated"
    />

    <ConvocationPreview
        v-if="previewMeeting"
        :meeting="previewMeeting"
        :ofObjId="ofObjId"
        :readOnly="previewReadOnly"
        :userAccountObjId="userAccountObjId"
        @close="closePreview"
        @sent="async () => {
    previewMeeting = null
    previewReadOnly = false
    await loadMeetings()
  }"
    />

    <MeetingFormPreview
        v-if="previewMeetingForm"
        :meeting="previewMeetingForm"
        :ofObjId="ofObjId"
        :userAccountObjId="userAccountObjId"
        :planning="previewPlanningForm"
        @close="closeMeetingFormPreview"
    />

    <AvisOFModal
        v-if="avisOFMeetingId != null"
        :candidateUrl="avisOFUrl"
        :ofObjId="ofObjId"
        :userAccountObjId="userAccountObjId"
        :meetingId="avisOFMeetingId"
        @close="avisOFUrl = null; avisOFMeetingId = null"
    />

    <input
        ref="meetingFormEvaFileInput"
        class="meeting-form-upload-input"
        type="file"
        @change="handleMeetingFormEvaFileChange"
    />

  </div>
</template>

<script setup>
import {computed, nextTick, onBeforeUnmount, onMounted, ref} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {usePlanningStore} from '@/store/planningStore'
import {storeToRefs} from 'pinia'
import {usePlanningStatus} from '@/composables/usePlanningStatus'
import {useDateFormatter} from '@/composables/useDateFormatter'
import {formatPersonDisplayName} from '@/composables/useSearchAutocomplete'
import {CALENDAR_CONFIG, PLANNING_STATUS} from '@/constants/planning'
import MeetingEdit from './MeetingEdit.vue'
import PlanningEdit from './PlanningEdit.vue'
import MonthlyCalendar from '@/components/UI/MonthlyCalendar.vue'
import LogoutButton from './LogoutButton.vue'
import ConvocationPreview from './ConvocationPreview.vue'
import MeetingFormPreview from './MeetingFormPreview.vue'
import Header from './Header.vue'
import multi from '@/assets/img/multi.png'
import stylo from '@/assets/img/stylo.svg'
import avisOf from '@/assets/img/avis_of.png'

// Import du nouveau composant
import MeetingDetails from './MeetingDetails.vue'
import AvisOFModal from './AvisOFModal.vue'
import dayjs from 'dayjs'
import 'dayjs/locale/fr'
import RouteEnum from "@/router/RouteEnum";

dayjs.locale('fr')

const route = useRoute()
const router = useRouter()
const planningStore = usePlanningStore()
const {authVars, loading, error} = storeToRefs(planningStore)
const {getStatusText, getStatusClass} = usePlanningStatus()
const {formatDate, formatTime, formatDateTime, formatDateString} = useDateFormatter()

const planningList = ref([])
const selectedMeeting = ref(null)
const associatedPlanningToSelectedMeeting = ref(null)
const selectedPlanning = ref(null)
const ofObjId = computed(() => route.params.ofObjId)
const userAccountObjId = computed(() => route.params.userAccountObjId)
const planningId = computed(() => route.params.planningId)
const loadingInvitation = ref(null)
const showDetails = ref(false)
const meetingDetails = ref([])
const detailsLoading = ref(false)
const previewMeeting = ref(null)
const previewReadOnly = ref(false)
const updatingMeetingVisibilityIds = ref([])
const creatingMeetingFormIds = ref([])
const downloadingMeetingFormIds = ref([])
const exportingMeetingFormToEvaIds = ref([])
const previewMeetingForm = ref(null)
const previewPlanningForm = ref(null)
const meetingFormEvaFileInput = ref(null)
const pendingMeetingForEvaExport = ref(null)
const openMeetingFormDropdownId = ref(null)
const avisOFUrl = ref(null)
const avisOFMeetingId = ref(null)
const openingAvisOFMeetingId = ref(null)

const firstPlanningDate = computed(() => {
  const firstPlanning = planningList.value[0]
  if (!firstPlanning?.startAt) return null
  return dayjs(firstPlanning.startAt)
})

const currentStartMonth = computed(() => {
  return (firstPlanningDate.value || dayjs()).startOf('month')
})

const firstPlanningDateString = computed(() => {
  if (!firstPlanningDate.value) return null
  return firstPlanningDate.value.format('YYYY-MM-DD')
})

// Computed properties pour le calendrier
const monthsToDisplay = computed(() => {
  const months = []
  for (let i = 0; i < 3; i++) {
    const m = currentStartMonth.value.add(i, 'month')
    months.push({
      key: m.format('YYYY-MM'),
      name: m.format('MMMM YYYY'),
      year: m.year(),
      monthIndex: m.month(),
      daysInMonth: m.daysInMonth(),
      firstDayOfWeek: (m.startOf('month').day() + 6) % 7
    })
  }
  return months
})

const hasProposedMeetings = (meetingList) => {
  return meetingList.some(meeting => meeting.statut === 20)
}

const toggleMeetingVisibility = async (meeting, isPublic) => {
  const previousValue = meeting.public

  if (previousValue === isPublic || updatingMeetingVisibilityIds.value.includes(meeting.id)) return

  updatingMeetingVisibilityIds.value = [...updatingMeetingVisibilityIds.value, meeting.id]
  meeting.public = isPublic

  try {
    const updateData = {
      candidacyObjId: meeting.candidacyObjId,
      meetingStatut: meeting.statut,
      public: isPublic
    }

    await planningStore.updateMeeting(
        ofObjId.value,
        userAccountObjId.value,
        meeting.id,
        updateData
    )
  } catch (err) {
    meeting.public = previousValue
    error.value = err?.message || err || 'Erreur lors de la mise à jour de la visibilité du créneau'
  } finally {
    updatingMeetingVisibilityIds.value = updatingMeetingVisibilityIds.value.filter(id => id !== meeting.id)
  }
}

const toggleDetails = async (event) => {
  console.log('toggleDetails called, showDetails:', showDetails.value, 'event.checked:', event.target.checked)
  showDetails.value = event.target.checked
  if (showDetails.value) {
    await fetchAllDetails()
  } else {
    meetingDetails.value = []
  }
  console.log('toggleDetails ended, showDetails:', showDetails.value)
}

const fetchAllDetails = async () => {
  detailsLoading.value = true
  meetingDetails.value = []

  const promises = []

  for (const planning of planningList.value) {
    for (const meeting of planning.meetingList) {
      if (meeting.candidacyObjId) {
        // On stocke la promesse
        const promise = planningStore.fetchCandidacyDetails(
            ofObjId.value,
            userAccountObjId.value,
            meeting.id
        ).then((details) => {
          meetingDetails.value.push({
            meeting,
            planning,
            details
          })
        })
        promises.push(promise)
      }
    }
  }

  try {
    // On attend que TOUTES les requêtes soient terminées
    await Promise.all(promises)
  } catch (err) {
    console.error('Erreur lors de la récupération des détails:', err)
    error.value = 'Erreur lors de la récupération des détails des meetings'
  } finally {
    detailsLoading.value = false
  }
}


const openPreview = (meeting) => {

  if (meeting.meetLink && !meeting.meetLink.startsWith('http')) {
    if (!window.confirm("Le lien visio n'est pas configuré, souhaitez-vous tout de même envoyer la convocation ?")) {
      return
    }
  }
  previewReadOnly.value = false
  previewMeeting.value = meeting
}

const openReadonlyPreview = (meeting) => {
  previewReadOnly.value = true
  previewMeeting.value = meeting
}

const openMeetLink = (meeting) => {
  if (typeof meeting?.meetLink !== 'string') return

  const rawLink = meeting.meetLink.trim()
  if (!rawLink) return

  if (!rawLink.startsWith('http')) {
    alert('Le lien visio n\'est pas configuré')
    return
  }

  try {
    const parsedUrl = new URL(rawLink)
    if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') return
    window.open(parsedUrl.toString(), '_blank', 'noopener,noreferrer')
  } catch {
    // Ignore invalid URL
  }
}

const closePreview = () => {
  previewMeeting.value = null
  previewReadOnly.value = false
}

const canOpenReadonlyConvocationPreview = (meeting) => {
  return meeting.statut === 30 || meeting.statut === 31 ||meeting.statut === 40 || meeting.statut === 50 || meeting.statut === 60
}

const canCreateMeetingForm = (meeting) => {
  return meeting?.candidacyObjId != null && meeting?.meetingForm == null
}

const canPreviewMeetingForm = (meeting) => {
  return meeting?.candidacyObjId != null && meeting?.meetingForm != null
}

const canDownloadMeetingForm = (meeting) => {
  return meeting?.candidacyObjId != null
}

const hasMeetingFormActions = (meeting) => {
  return canCreateMeetingForm(meeting)
      || canPreviewMeetingForm(meeting)
      || canDownloadMeetingForm(meeting)
}

const toggleMeetingFormDropdown = (meetingId) => {
  openMeetingFormDropdownId.value = openMeetingFormDropdownId.value === meetingId ? null : meetingId
}

const closeMeetingFormDropdown = () => {
  openMeetingFormDropdownId.value = null
}

const handleMeetingRowMouseLeave = (meetingId) => {
  if (
      openMeetingFormDropdownId.value === meetingId
      && !isMeetingFormEvaExportPendingOrRunning(meetingId)
  ) {
    closeMeetingFormDropdown()
  }
}

const isMeetingFormActionBusy = (meetingId) => {
  return creatingMeetingFormIds.value.includes(meetingId)
      || downloadingMeetingFormIds.value.includes(meetingId)
      || exportingMeetingFormToEvaIds.value.includes(meetingId)
}

const handleMeetingFormOnlineAction = async (meeting, planning) => {
  closeMeetingFormDropdown()
  if (canCreateMeetingForm(meeting)) {
    await createMeetingForm(meeting, planning)
    return
  }
  if (canPreviewMeetingForm(meeting)) {
    openMeetingFormPreview(meeting, planning)
  }
}

const handleMeetingFormPdfAction = (meeting) => {
  closeMeetingFormDropdown()
  downloadMeetingFormPdf(meeting)
}

const handleMeetingFormEvaExportAction = (meeting) => {
  triggerMeetingFormEvaExportUpload(meeting)
}

const handleAvisOFAction = async (meeting) => {
  if (openingAvisOFMeetingId.value === meeting.id) return
  closeMeetingFormDropdown()
  openingAvisOFMeetingId.value = meeting.id
  try {
    const detail = await planningStore.fetchCandidacyDetails(
        ofObjId.value,
        userAccountObjId.value,
        meeting.id
    )
    avisOFUrl.value = detail?.['Fiche candidat']?.url || null
    avisOFMeetingId.value = meeting.id
  } catch (err) {
    error.value = err?.message || err || 'Erreur lors de l\'ouverture de l\'avis OF'
  } finally {
    openingAvisOFMeetingId.value = null
  }
}

const isMeetingFormEvaExportPendingOrRunning = (meetingId) => {
  return pendingMeetingForEvaExport.value?.id === meetingId
      || exportingMeetingFormToEvaIds.value.includes(meetingId)
}

const createMeetingFormIfNeeded = async (meeting) => {
  if (meeting?.meetingForm != null) return meeting.meetingForm
  if (creatingMeetingFormIds.value.includes(meeting.id)) return null

  creatingMeetingFormIds.value = [...creatingMeetingFormIds.value, meeting.id]

  try {
    const meetingForm = await planningStore.createMeetingForm(
        ofObjId.value,
        userAccountObjId.value,
        meeting.id
    )
    meeting.meetingForm = meetingForm
    return meetingForm
  } finally {
    creatingMeetingFormIds.value = creatingMeetingFormIds.value.filter(id => id !== meeting.id)
  }
}

const extractFilenameFromContentDisposition = (contentDisposition) => {
  if (typeof contentDisposition !== 'string' || contentDisposition.trim() === '') return ''

  const utf8Match = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]).replace(/^["']|["']$/g, '')
  }

  const asciiMatch = contentDisposition.match(/filename\s*=\s*"?([^";]+)"?/i)
  if (asciiMatch?.[1]) return asciiMatch[1].trim()

  return ''
}

const sanitizeFilename = (filename, fallbackMeetingId) => {
  if (typeof filename === 'string' && filename.trim() !== '') {
    const cleaned = filename.replace(/[\\/:*?"<>|]/g, '_').trim()
    if (cleaned) return cleaned
  }

  return `grille-entretien-${fallbackMeetingId}.pdf`
}

const triggerFileDownload = (blob, filename) => {
  const blobUrl = window.URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = blobUrl
  anchor.download = filename
  anchor.style.display = 'none'
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  window.setTimeout(() => window.URL.revokeObjectURL(blobUrl), 0)
}

const createMeetingForm = async (meeting, planning) => {
  try {
    const meetingForm = await createMeetingFormIfNeeded(meeting)
    if (!meetingForm) return
    openMeetingFormPreview(meeting, planning)
  } catch (err) {
    error.value = err?.message || err || 'Erreur lors de la création de la grille d\'entretien'
  }
}

const openMeetingFormPreview = (meeting, planning) => {
  previewMeetingForm.value = meeting
  previewPlanningForm.value = planning
}

const downloadMeetingFormPdf = async (meeting) => {
  if (isMeetingFormActionBusy(meeting.id)) return

  downloadingMeetingFormIds.value = [...downloadingMeetingFormIds.value, meeting.id]

  try {
    await createMeetingFormIfNeeded(meeting)

    const response = await planningStore.getMeetingFormPreviewPdf(
        ofObjId.value,
        userAccountObjId.value,
        meeting.id
    )

    const blob = response?.data instanceof Blob
        ? response.data
        : new Blob([response?.data], {type: 'application/pdf'})
    const contentDisposition = response?.headers?.['content-disposition'] || response?.headers?.['Content-Disposition']
    const extractedFilename = extractFilenameFromContentDisposition(contentDisposition)
    const filename = sanitizeFilename(extractedFilename, meeting.id)

    triggerFileDownload(blob, filename)
  } catch (err) {
    error.value = err?.message || err || 'Erreur lors du téléchargement de la grille d\'entretien'
  } finally {
    downloadingMeetingFormIds.value = downloadingMeetingFormIds.value.filter(id => id !== meeting.id)
  }
}

const triggerMeetingFormEvaExportUpload = (meeting) => {
  if (isMeetingFormActionBusy(meeting.id)) return
  if (!meetingFormEvaFileInput.value) return

  pendingMeetingForEvaExport.value = meeting
  meetingFormEvaFileInput.value.value = ''
  meetingFormEvaFileInput.value.click()

}

const handleMeetingFormEvaFileChange = async (event) => {
  const selectedFile = event?.target?.files?.[0]
  const meeting = pendingMeetingForEvaExport.value

  if (event?.target) {
    event.target.value = ''
  }
  pendingMeetingForEvaExport.value = null

  if (!selectedFile || !meeting?.id) return
  if (isMeetingFormActionBusy(meeting.id)) return

  exportingMeetingFormToEvaIds.value = [...exportingMeetingFormToEvaIds.value, meeting.id]

  try {
    await planningStore.exportMeetingFormToEva(
        ofObjId.value,
        userAccountObjId.value,
        meeting.id,
        selectedFile
    )
    meeting.statut = PLANNING_STATUS.COMPLETED;
    try {
      const detail = await planningStore.fetchCandidacyDetails(
          ofObjId.value,
          userAccountObjId.value,
          meeting.id
      )
      const candidateUrl = detail?.['Fiche candidat']?.url
      if (candidateUrl) {
        avisOFUrl.value = candidateUrl
        avisOFMeetingId.value = meeting.id
      }
    } catch (err) {
      console.error('Impossible d\'ouvrir la fiche candidat après export EVA:', err)
    }
  } catch (err) {
    error.value = err?.message || err || 'Erreur lors de l\'export vers EVA'
  } finally {
    exportingMeetingFormToEvaIds.value = exportingMeetingFormToEvaIds.value.filter(id => id !== meeting.id)
    if (openMeetingFormDropdownId.value === meeting.id) {
      closeMeetingFormDropdown()
    }
  }
}

const closeMeetingFormPreview = () => {
  previewMeetingForm.value = null
  previewPlanningForm.value = null
}

const hasMeetingComment = (meeting) => {
  return typeof meeting?.comments === 'string' && meeting.comments.trim().length > 0
}

const truncateComment = (comment, maxLength = 70) => {
  if (typeof comment !== 'string') return ''
  const normalized = comment.replace(/\s+/g, ' ').trim()
  if (normalized.length <= maxLength) return normalized
  return `${normalized.slice(0, maxLength)}...`
}


const printWithDetails = async () => {
  try {
    if (!showDetails.value) {
      showDetails.value = true
      await fetchAllDetails()
    }

    await nextTick()
    window.setTimeout(() => {
      window.print()
    }, 1000);

  } catch (err) {
    console.error('Erreur lors de la préparation à l’impression :', err)
    error.value = 'Impossible d’imprimer les fiches pour le moment.'
  }
}

const hasPlanningOnDate = (y, m, d) => {
  if (!firstPlanningDateString.value) return false
  return formatDateString(y, m, d) === firstPlanningDateString.value
}

const isSelected = (y, m, d) => {
  if (!firstPlanningDateString.value) return false
  return formatDateString(y, m, d) === firstPlanningDateString.value
}

const loadMeetings = async () => {
  return planningStore.fetchMeetings(ofObjId.value, userAccountObjId.value, planningId.value).then((data) => {
    planningList.value = data.planningList
    const { editCandidacy, ...query } = route.query
    if (typeof editCandidacy === 'string' && /^[1-9][0-9]*$/.test(editCandidacy)) {
      for (const planning of planningList.value) {
        const meeting = planning.meetingList.find(item => String(item.candidacyObjId) === editCandidacy)
        if (meeting) {
          editMeeting(meeting, planning)
          break
        }
      }
    }
    if (editCandidacy !== undefined) {
      router.replace({ query })
    }
  }).catch((err) => {
    console.error('Erreur lors du chargement des créneaux:', err)
  })
}

const homePage = () => {
  router.push({
    name: RouteEnum.PLANNING_VIEW,
    params: {
      userAccountObjId: userAccountObjId.value,
      ofObjId: ofObjId.value,
    }
  })
}

const goPlanning = () => {
  router.push({
    name: RouteEnum.PLANNING_LIST,
    params: {
      ofObjId: ofObjId.value,
      userAccountObjId: userAccountObjId.value,
    }
  })
}

onMounted(() => {
  showDetails.value = false
  document.addEventListener('click', handleDocumentClick)
  loadMeetings()
})

const minStartDate = computed(() => {
  if (planningList.value.length === 0) return ''
  return Math.min(...planningList.value.map(p => new Date(p.startAt)))
})

const maxEndDate = computed(() => {
  if (planningList.value.length === 0) return ''
  return Math.max(...planningList.value.map(p => new Date(p.endAt)))
})

const editMeeting = (meeting, planning) => {
  selectedMeeting.value = {...meeting}
  associatedPlanningToSelectedMeeting.value = {...planning}

}

const editPlanning = (planning) => {
  selectedPlanning.value = planning
}

const handleMeetingUpdated = async () => {
  selectedMeeting.value = null
  associatedPlanningToSelectedMeeting.value = null
  await loadMeetings()
  if (showDetails.value) {
    await fetchAllDetails()
  }
}

const handleMeetingClosed = () => {
  selectedMeeting.value = null
  associatedPlanningToSelectedMeeting.value = null
  error.value = null
}

const handlePlanningUpdated = () => {
  selectedPlanning.value = null
  loadMeetings()
}

const handlePlanningClosed = () => {
  selectedPlanning.value = null
  error.value = null
}

const clearError = () => {
  planningStore.clearError()
}

const handleDocumentClick = () => {
  if (isMeetingFormEvaExportPendingOrRunning(openMeetingFormDropdownId.value)) return
  closeMeetingFormDropdown()
}

onBeforeUnmount(() => {
  document.removeEventListener('click', handleDocumentClick)
})
</script>

<style scoped>
/* Styles existants inchangés */
.planning-section {
  margin-bottom: 40px;
}

.meeting-multi {
  position: relative;
  vertical-align: middle;
  text-align: center;
}

.meeting-multi::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: var(--multi-bg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.2;
  pointer-events: none;
}

.meeting-table.selected {
  border: 2px solid var(--primary);
  background-color: #f0f8ff;
}

.table-meeting td {
  vertical-align: middle;
}

.status-preview-btn {
  width: 28px;
  height: 28px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: linear-gradient(145deg, #ffffff, #f1f4f8);
  border-radius: 999px;
  margin-left: 6px;
  padding: 0;
  cursor: pointer;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;
  color: #2f3a4a;
}

.status-preview-btn:hover {
  transform: translateY(-1px);
  border-color: rgba(0, 0, 0, 0.22);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
}

.status-preview-icon {
  width: 16px;
  height: 16px;
  fill: currentColor;
}

.meeting-form-download-loading {
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  color: #2f3a4a;
}

.planning .invitation-btn {
  background: linear-gradient(135deg, #ff9800, #f57c00);
  border: 1px solid #e65100;
  color: white;
  font-weight: 500;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.planning .invitation-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #f57c00, #ef6c00);
  transform: translateY(-1px);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
}

.planning .invitation-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.planning .btn-content {
  display: flex;
  align-items: center;
  gap: 4px;
}

.planning .warning-icon {
  font-size: 14px;
  filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.3));
}

.meeting-visibility-cell {
  white-space: nowrap;
}

.meeting-form-cell {
  text-align: center;
  position: relative;
}

.meeting-form-dropdown {
  display: inline-flex;
  position: relative;
  align-items: center;
}

.meeting-form-dropdown-trigger {
  margin-left: 0;
}

.meeting-form-dropdown-trigger-icon {
  font-size: 18px;
  line-height: 1;
  color: #2f3a4a;
  transform: translateY(-1px);
}

.meeting-form-dropdown-menu {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 220px;
  padding: 4px;
  background: #fff;
  border: 1px solid rgba(47, 58, 74, 0.18);
  border-radius: 8px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  z-index: 20;
}

.meeting-form-dropdown-item {
  width: 100%;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #2f3a4a;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 8px;
  text-align: left;
  font-size: 0.82rem;
  cursor: pointer;
}

.meeting-form-dropdown-item:hover:not(:disabled) {
  background: #f4f7fb;
}

.meeting-form-dropdown-item:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.meeting-form-dropdown-item-icon {
  width: 18px;
  min-width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.meeting-form-online-create-icon {
  font-size: 16px;
  font-weight: 700;
  color: var(--primary);
}

.meeting-form-upload-input {
  display: none;
}

.meeting-status-cell {
  white-space: nowrap;
}

.meeting-status-content {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.meeting-status-actions {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.meeting-status-actions .status-preview-btn {
  margin-left: 0;
}

.meeting-comments-cell {
  max-width: 280px;
}

.comment-trigger {
  width: 100%;
  border: 1px solid transparent;
  border-radius: 4px;
  background: transparent;
  text-align: left;
  color: #3d4852;
}

.comment-trigger:hover {
  background: #f5f7fb;
}

.comment-empty {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 28px;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--primary);
}

.comment-text {
  display: inline-block;
  max-width: 100%;
  text-overflow: ellipsis;
}

.visibility-switch {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
  margin: 0;
}

.visibility-switch input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.visibility-slider {
  position: relative;
  width: 42px;
  height: 24px;
  border-radius: 999px;
  background-color: #c9ced6;
  transition: background-color 0.2s ease;
}

.visibility-slider::before {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
  transition: transform 0.2s ease;
}

.visibility-switch input:checked + .visibility-slider {
  background-color: var(--primary);
}

.visibility-switch input:checked + .visibility-slider::before {
  transform: translateX(18px);
}

.visibility-switch input:disabled + .visibility-slider {
  opacity: 0.6;
}

.visibility-switch input:disabled ~ .visibility-label {
  opacity: 0.6;
}

.visibility-label {
  font-size: 0.8rem;
  color: #4a4f55;
}

/* Nouveaux styles pour la section + de détails */
.details-button-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 1rem;
}

/* Checkbox aligné à droite */
.details-top-row {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

/* Bouton imprimer centré */
.print-button-wrapper {
  display: flex;
  justify-content: center;
  width: 100%;
}


.details-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #7f8c8d;
  font-weight: 400;
}

.details-checkbox input[type="checkbox"] {
  cursor: pointer;
}

.details-checkbox input[type="checkbox"]:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.checkbox-label {
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.checkbox-label:hover {
  opacity: 1;
}

@media print {
  .header, .header-actions, .details-button-container, .MonthlyCalendar, .calendar-wrapper, .invitation-btn {
    display: none;
  }
}
</style>
